import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Services from './components/Services';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import ServiceAreas from './components/ServiceAreas';
import Footer from './components/Footer';
import './styles/main.css';

const App = () => {
  const [theme, setTheme] = useState('light');
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  const [headerScrolled, setHeaderScrolled] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
      setHeaderScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const scrollToTop = () => {
    // Try smooth scroll then ensure scroll position is reset for browsers
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    // Ensure instant reset as fallback
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  const handleNavClick = (page) => {
    setCurrentPage(page);
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    // Wait a tick so content/layout updates, then scroll to top
    const t = setTimeout(() => scrollToTop(), 50);
    return () => clearTimeout(t);
  }, [currentPage]);

  return (
    <>
      <Header 
        theme={theme}
        toggleTheme={toggleTheme}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        handleNavClick={handleNavClick}
        headerScrolled={headerScrolled}
      />

      {currentPage === 'home' && (
        <>
          <Hero handleNavClick={handleNavClick} />
          <Features />
          <Services handleNavClick={handleNavClick} isPreview={true} />
        </>
      )}

      {currentPage === 'services' && (
        <Services handleNavClick={handleNavClick} isPreview={false} />
      )}

      {currentPage === 'contact' && (
        <Contact />
      )}

      {currentPage === 'service-areas' && (
        <ServiceAreas />
      )}

      {currentPage === 'faq' && (
        <FAQ handleNavClick={handleNavClick} isPreview={false} />
      )}

      <Footer handleNavClick={handleNavClick} />

      <button 
        className={`scroll-top ${showScrollTop ? 'visible' : ''}`}
        onClick={scrollToTop}
      >
        <ChevronUp size={24} />
      </button>
    </>
  );
};

export default App;